import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import CustomerLayout from "./components/CustomerLayout";
import Home from "./pages/Home";
import Cars from "./pages/Cars";
import CarDetail from "./pages/CarDetail";
import LatestArrivals from "./pages/LatestArrivals";
import TestDrive from "./pages/TestDrive";
import SellYourCar from "./pages/SellYourCar";
import EMICalculator from "./pages/EMICalculator";
import Reviews from "./pages/Reviews";
import About from "./pages/About";
import Contact from "./pages/Contact";

import AdminLayout from "./admin/AdminLayout";
import AdminLogin from "./admin/AdminLogin";
import AdminForgotPassword from "./admin/AdminForgotPassword";
import AdminResetPassword from "./admin/AdminResetPassword";
import AdminDashboard from "./admin/AdminDashboard";
import AdminInventory from "./admin/AdminInventory";
import AdminVehicleEdit from "./admin/AdminVehicleEdit";
import AdminTestDrives from "./admin/AdminTestDrives";
import AdminSellLeads from "./admin/AdminSellLeads";
import AdminLeads from "./admin/AdminLeads";
import AdminReviews from "./admin/AdminReviews";
import AdminSettings from "./admin/AdminSettings";
import AdminAI from "./admin/AdminAI";
import AdminImportCarTrade from "./admin/AdminImportCarTrade";
import AdminImportHistory from "./admin/AdminImportHistory";
import AdminImportCarWalePhotos from "./admin/AdminImportCarWalePhotos";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CustomerLayout />}>
            <Route index element={<Home />} />
            <Route path="cars" element={<Cars />} />
            <Route path="cars/:slug" element={<CarDetail />} />
            <Route path="latest-arrivals" element={<LatestArrivals />} />
            <Route path="test-drive" element={<TestDrive />} />
            <Route path="sell-your-car" element={<SellYourCar />} />
            <Route path="emi-calculator" element={<EMICalculator />} />
            <Route path="reviews" element={<Reviews />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="inventory" element={<AdminInventory />} />
            <Route path="inventory/:id" element={<AdminVehicleEdit />} />
            <Route path="test-drives" element={<AdminTestDrives />} />
            <Route path="sell-leads" element={<AdminSellLeads />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="ai" element={<AdminAI />} />
            <Route path="imports/cartrade" element={<AdminImportCarTrade />} />
            <Route path="imports/photos" element={<AdminImportCarWalePhotos />} />
            <Route path="imports/history" element={<AdminImportHistory />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
